import { loadContacts } from "../common/api";

const model = {
    name: 'contacts',
    state: { 
        loaded: false,
        currentId: '',
        byId: {},
        byEmail: {},
        byPhone: {}
    },
    reducers: {
        setCurrentId: ( state, payload ) => {
            return {
                ...state,
                currentId: payload.cid
            }
        },
        cdcInsert: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.cid]: { ...payload.cdc }
                },
                byEmail: {
                    ...state.byEmail,
                    [payload.cdc.email]: payload.cid
                }
            }
        },
        cdcModify: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.cid]: {
                        ...state.byId[payload.cid],
                        ...payload.cdc
                    }
                },
                byEmail: {
                    ...state.byEmail,
                    [payload.cdc.email]: payload.cid
                }
            }
        },
        cdcRemove: ( state, payload ) => {
            const keys = Object.keys( state.byId ).filter( f => f !== payload.cid );
            let newObj = {};
            keys.forEach( k => newObj[k] = state.byId[k] );
            return {
                ...state,
                byId: newObj
            }
        },
        loadedContacts: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    ...payload.id
                },
                byEmail: {
                    ...state.byEmail,
                    ...payload.e
                },
                byPhone: {
                    ...state.byPhone,
                    ...payload.p
                },
                loaded: true
            }
        }
    },
    effects: ( dispatch ) => ( {
        async loadContacts( { orgId, aid, uid, segment } ) {
            const list = await loadContacts( orgId, aid, uid, segment );
            
            let byId = {};
            let byEmail = {};
            let byPhone = {};
            
            list.forEach( c => {
                byId[c.cid] = c;

                if ( c.email && c.email.length ) {
                    byEmail[c.email.toLowerCase()] = c.cid;
                }
                if ( c.emailPartner1 && c.emailPartner1.length ) {
                    byEmail[c.emailPartner1.toLowerCase()] = c.cid;
                }
                if ( c.emailPartner2 && c.emailPartner2.length ) {
                    byEmail[c.emailPartner2.toLowerCase()] = c.cid;
                }
                if ( c.phone && c.phone.length ) {
                    const p = c.phone.replace( /\D+/g, '' );
                    byPhone[p] = c.cid;
                }
                if ( c.phoneMobile && c.phoneMobile.length ) {
                    const p = c.phoneMobile.replace( /\D+/g, '' );
                    byPhone[p] = c.cid;
                }
                if ( c.phoneWork && c.phoneWork.length ) {
                    const p = c.phoneWork.replace( /\D+/g, '' );
                    byPhone[p] = c.cid;
                }
            } );

            dispatch.contacts.loadedContacts( { id: byId, e: byEmail, p: byPhone } );
        },
        insert( { cid, cdc } ) {
            dispatch.contacts.cdcInsert( { cid, cdc } );
        },
        modify( { cid, cdc } ) {
            dispatch.contacts.cdcModify( { cid, cdc } );
        },
        remove( { cid } ) {
            dispatch.contacts.cdcRemove( { cid } );
        },
        setCurrent( { cid } ) {
            dispatch.contacts.setCurrentId( { cid } );
        }
    } )
}

export default model;